export default __webpack_public_path__ + "static/media/banner-gmm-past.6f64d0fa.jpg";